import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import axios from "axios";

async function getContractAttachments(searchType, notice_id) {
  if (searchType !== "federal") return [];
  if (!notice_id) return [];
  try {
    const response = await axios.get(
      `https://sam.gov/api/prod/opps/v3/opportunities/${notice_id}/resources`
    );
    return (
      response.data?._embedded?.opportunityAttachmentList?.[0]?.attachments ||
      []
    );
  } catch (error) {
    console.error("Failed to fetch contract attachments:", error);
    return [];
  }
}

export function useGetContractAttachments(searchType, noticeId) {
  return useQuery({
    queryKey: ["federal-attachments", noticeId],
    queryFn: () => getContractAttachments(searchType, noticeId),
    onError: () => {},
  });
}
